import { render, staticRenderFns } from "./JobHistory.vue?vue&type=template&id=1da2fa65&scoped=true&"
import script from "./JobHistory.vue?vue&type=script&lang=ts&"
export * from "./JobHistory.vue?vue&type=script&lang=ts&"
import style0 from "./JobHistory.vue?vue&type=style&index=0&id=1da2fa65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da2fa65",
  null
  
)

export default component.exports